import type { IToastState } from './types'
import type { Selector } from 'store'

import { NAME } from './constants'

export const selectToast: Selector<IToastState> = state => state[NAME]
